import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const r = () => /* @__PURE__ */ o.jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m5.25 13H6.75a1 1 0 0 1 0-2h10.5a1 1 0 0 1 0 2m0 0"
  }
) });
export {
  r as R
};
